'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidTextsms = function IoAndroidTextsms(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.9 5c1.7 0 3.1 1.4 3.1 3.1v18.8c0 1.7-1.4 3.1-3.1 3.1h-21.9l-5 5v-26.9c0-1.7 0.8-3.1 2.5-3.1h24.4z m-16.4 13.9v-3.1h-3v3.1h3z m6 0v-3.1h-3v3.1h3z m6 0v-3.1h-3v3.1h3z' })
        )
    );
};

exports.default = IoAndroidTextsms;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-textsms.js
// module id = 1916
// module chunks = 0